import React from 'react';
import { cssColorValue, KeyboardDetectionProvider, makeColorSetClass, screenSmMax, screenXlMin, screenXxsMax, spacer16, spacer24, spacer32, spacer40, spacer48, spacer56, } from '@spotify-internal/encore-web';
import styled from 'styled-components';
import { Logo } from './Logo';
import { FooterContent } from './Content';
import { FooterSocial } from './Social';
import { FooterCopyrightPolicies } from './CopyrightPolicies';
import { FooterLanguage } from './Language';
import { useS4AMastheadContext } from '../S4AMastheadProvider';
import { MAX_CONTENT_WIDTH } from '../constants';
const FooterWrapper = styled.footer `
  background-color: ${props => { var _a, _b; return (_b = (_a = props === null || props === void 0 ? void 0 : props.colors) === null || _a === void 0 ? void 0 : _a.background) !== null && _b !== void 0 ? _b : cssColorValue('backgroundBase'); }};
  color: ${props => { var _a, _b; return (_b = (_a = props === null || props === void 0 ? void 0 : props.colors) === null || _a === void 0 ? void 0 : _a.primaryText) !== null && _b !== void 0 ? _b : cssColorValue('textBase'); }};
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: ${spacer56} ${spacer40} 0;
  gap: 96px;

  @media (max-width: ${screenSmMax}) {
    padding: ${spacer48} ${spacer40} 0;
    gap: ${spacer40};
    align-items: flex-start;
  }

  @media (max-width: ${screenXxsMax}) {
    padding: ${spacer48} ${spacer16} 0;
  }

  @media (min-width: ${screenXlMin}) {
    padding-inline: ${spacer48};
  }
  // max content width of 1520px
  @media (min-width: ${MAX_CONTENT_WIDTH}) {
    padding-inline: calc((100% - 1520px) / 2);
  }
`;
const FooterContentWrapper = styled.div `
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 0px;
  gap: ${spacer24};
  width: 100%;
  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;

  @media (max-width: ${screenSmMax}) {
    flex-direction: column;
    gap: 54px;
  }
  @media (max-width: ${screenXxsMax}) {
    gap: ${spacer48};
  }
`;
const SubFooterWrapper = styled.div `
  border-top: solid 1px
    ${props => { var _a, _b; return (_b = (_a = props === null || props === void 0 ? void 0 : props.colors) === null || _a === void 0 ? void 0 : _a.border) !== null && _b !== void 0 ? _b : cssColorValue('decorativeSubdued'); }};
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  gap: ${spacer24};
  flex: none;
  flex-direction: row;
  padding: ${spacer32} 0 ${spacer32} 0;
  @media (max-width: ${screenSmMax}) {
    flex-direction: column;
    padding: ${spacer24} 0 ${spacer24} 0;
  }
`;
export const Footer = ({ colors }) => {
    const { mastheadData, language } = useS4AMastheadContext();
    if (!mastheadData) {
        return null;
    }
    const footerEntry = mastheadData.fields.footer;
    const languageSelectionEntry = mastheadData.fields
        .languageSelection;
    return (React.createElement(KeyboardDetectionProvider, null,
        React.createElement(FooterWrapper, { className: makeColorSetClass('invertedDark'), colors: colors },
            React.createElement(FooterContentWrapper, null,
                React.createElement(Logo, { colors: colors }),
                React.createElement(FooterContent, { colors: colors, footerEntry: footerEntry }),
                React.createElement(FooterSocial, { colors: colors })),
            React.createElement(SubFooterWrapper, { colors: colors },
                React.createElement(FooterCopyrightPolicies, { colors: colors, footerEntry: footerEntry }),
                React.createElement(FooterLanguage, { colors: colors, language: language, languageSelectionEntry: languageSelectionEntry })))));
};
//# sourceMappingURL=Footer.js.map